<template>
  <div
    v-show="show"
    class="fixed inset-x-0 bottom-0 z-40"
    id="banner-footer"
  >
    <div class="bg-blue-900">
      <div class="max-w-7xl mx-auto py-3 px-3 sm:px-6 lg:px-8 xl:py-4">
        <div class="flex items-center justify-between flex-wrap">
          <div class="w-0 flex-1 flex items-center text-white">
            <slot />
          </div>
          <div
            v-if="to !== ''"
            class="order-3 mt-2 flex-shrink-0 w-full sm:order-2 sm:mt-0 sm:w-auto"
          >
            <!-- eslint-disable max-len -->
            <a
              :href="to"
              target="_blank"
              rel="nofollow"
              class="flex items-center justify-center px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-blue-900 bg-white hover:bg-blue-100"
            >
              Learn more
            </a>
            <!-- eslint-enable max-len -->
          </div>
          <div class="order-2 flex-shrink-0 sm:order-3 sm:ml-3">
            <m-button @click="handleDismiss" data-test="banner-footer-dismiss">
              <span class="sr-only">Dismiss</span>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="h-6 w-6 text-white"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <!-- eslint-disable-next-line max-len -->
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            </m-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'm-banner',
  props: {
    id: {
      type: String,
      required: true,
    },
    to: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      show: true,
    };
  },
  methods: {
    handleDismiss() {
      this.show = false;
      this.$cookies.set(`seen-${this.id}-banner`, true, { expires: 30 });
      this.$mixpanel.track('banner', {
        action: 'dismiss',
        id: this.id,
      });
    },
    seenBanner() {
      this.show = !(this.$cookies.get(`seen-${this.id}-banner`) === 'true');
    },
  },
  mounted() {
    this.seenBanner();
  },
};
</script>
